module.exports = "/assets/32faf5e81404312f99cc4a5a19cfd50a.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/flights/assets/logos/J9.png
// module id = 1502
// module chunks = 0